import React from 'react';
import { ProgressBarStyle } from './ProgressBar.styles';

function ProgressBar({ level, bg }) {
  return <ProgressBarStyle $level={level} $bg={bg} />;
}

export default ProgressBar;
